module.exports = __webpack_public_path__ + "static/RootSans-11Black-a58778dc87aec69696bbded94a872203.woff2";